import { Component, OnInit, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';

import { WINDOW } from '@mimecast-ui/ui-core/window';
import { ConfigService } from '@mimecast-ui/universal-login/data-access-config';

import {
  buildLegacyHashRedirectUrl,
  extractHashSearchParams,
} from './legacy-hash-redirect.util';

@Component({
  imports: [RouterModule],
  selector: 'ul-root',
  template: '<router-outlet></router-outlet>',
})
export class App implements OnInit {
  private readonly router = inject(Router);
  private readonly window = inject(WINDOW);
  private readonly configService = inject(ConfigService);

  ngOnInit(): void {
    // Legacy MUL (AngularJS) used hash routing (#/login, #/reset-cloud-password, etc.). During
    // migration, inbound links may still land with a hash while this app uses
    // HTML5 paths under /login/. Rewrite on bootstrap so query params are kept.
    const { hash, search } = this.window.location;

    // provideLoginConfig snapshots window.location.search only. Secure-messaging
    // bridges keep message/link on the hash (`#/login?message=...`); fold those
    // into the bootstrap snapshot so PostLoginRedirectService still sees them.
    extractHashSearchParams(hash).forEach((value, key) => {
      this.configService.initialUrlParams.set(key, value);
    });

    const redirectUrl = buildLegacyHashRedirectUrl(hash, search);

    if (!redirectUrl) {
      return;
    }

    void this.router.navigateByUrl(redirectUrl, {
      replaceUrl: true,
    });
  }
}
